export default {"src":"/_next/static/media/projectIcon.da157d65.svg","height":100,"width":100};